module.exports = __webpack_public_path__ + "static/media/Mulish-Bold.0cf98fa2.svg";